import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TextInput from 'react/elements/TextInput';
import Button from 'react/components/Button';
import MaterialIcon from 'react/elements/MaterialIcon';
import { saveMealIdeaGroup, MEAL_IDEAS_LOADED } from 'redux/actions/mealIdeas';
import useOffline, { onlineOnly } from '../../hooks/useOffline';

/** Adds a meal idea group. Online-only, so offline the field and button are disabled, titled "Needs a connection". */
export default function NewMealIdeaGroupForm() {
	const dispatch = useDispatch();
	const offline = useOffline();
	const [name, setName] = useState('');
	const [submitting, setSubmitting] = useState(false);

	const submit = () => {
		const trimmed = name.trim();
		if(!trimmed || submitting) {
			return;
		}
		setSubmitting(true);
		dispatch(saveMealIdeaGroup(trimmed)).then((action) => {
			setSubmitting(false);
			if(action && action.type === MEAL_IDEAS_LOADED) {
				setName('');
			}
		});
	};

	return (
		<div className='new_meal_idea_group'>
			<MaterialIcon className='new_meal_idea_group__icon'>create_new_folder</MaterialIcon>
			<div className='input-field'>
				<TextInput
					label='New group'
					enterkeyhint='done'
					{...onlineOnly(offline)}
					value={name}
					onChange={(event) => setName(event.target.value)}
					onKeyDown={(event) => {
						if(event.key === 'Enter') {
							event.preventDefault();
							submit();
						}
					}}
				/>
			</div>
			<Button small onClick={submit} disabled={submitting || !name.trim()} {...onlineOnly(offline)}>Add group</Button>
		</div>
	);
}
